/*
 * @Description: apis
 * @Date: 2022-10-18 22:30:45
 * @Author: mazexin
 * @LastEditors: lrz
 */
import instance from '@/plugin/axios'
import { signParams } from '@/utils'

// export * from './folderTree'

// 提交预约咨询
export const contactus = (data = {}, config) => {
  const apiURL = `${process.env.REACT_APP_BASE_URL}/admin/official/Index/contactus`
  return instance({
    url: apiURL,
    method: 'post',
    data: data,
    ...config
  })
}

// --- ka/Upload : 上传处理管理 s
/**
 * 上传前检查是否已上传(如果已经存在则返回文件id)
 * @param {*} data
 */
export const foldersCheckUpload = (data = {}) => {
  return instance({
    url: '/creative/ka/Upload/checkUpload',
    method: 'post',
    data: data
  })
}
// --- ka/Upload : 上传处理管理 e

/**
 * 校验视频文件是否符合H2.64格式
 * @param {Object} params
 * - relative_file
 */
export const checkVideoFormatApi = (params = {}) => {
  return instance({
    method: 'get',
    url: '/creative/pcm/Video/checkVideoFormat',
    params,
    retry: 10,
    retryDelay: 1000
  })
}

// 检查转码
export const checkVideoTranscodeProgressApi = (params = {}, options = {}) => {
  return instance({
    method: 'get',
    url: `/creative/pcm/Video/checkVideoTranscodeProgress`,
    params,
    ...options
  })
}

// 获取用户信息 code拿用户信息 含open_id
export const getUserInfoByCode = (data = {}) => {
  return instance({
    url: '/admin/official/Wechat/wechatLogin',
    method: 'post',
    data: data
  })
}

// 获取用户信息 open_id拿用户信息 含open_id
export const getUserInfoByOpenid = (data = {}) => {
  return instance({
    url: '/admin/official/Wechat/getUserInfo',
    method: 'post',
    data: data
  })
}

// open_id拿kz token
export const getKzToken = (data = {}) => {
  return instance({
    url: '/user/user/Login/thirdAutoLoginForWechat',
    method: 'get',
    params: data
  })
}

// 视频解构器 视频详情接口
export const getVideoInfo = (params = {}, options = {}) => {
  return instance({
    method: 'get',
    url: `/creative/ka/CreativeElement/info`, // dam+视频详情
    // url: '/creative/ka/VideoDecode/detail', // real
    params,
    ...options
  })
}

// 获取dam+视频素材的口播文案
export const getOralBroadcast = (params = {}, options = {}) => {
  return instance({
    method: 'get',
    url: `/creative/ka/SubTitle/get`,
    params,
    ...options
  })
}

// 视频解构器视频列表
// 解构记录
export const videoDecodeList = (params = {}, options = {}) => {
  return instance({
    method: 'get',
    url: '/creative/ka/VideoDecode/list',
    params,
    ...options
  })
}
// 示例说明
export const videoDecodeDemoList = (params = {}, options = {}) => {
  return instance({
    method: 'get',
    url: '/creative/ka/VideoDecode/demoList',
    params,
    ...options
  })
}

// 视频解构器视频详情
export const videoDecodeDetail = (params = {}, options = {}) => {
  return instance({
    method: 'get',
    url: '/creative/ka/VideoDecode/detail',
    params,
    ...options
  })
}

// 发送短信验证码
export const sendSmsCode = (data = {}) => {
  return instance({
    url: '/user/user/Login/sendSmsCode',
    method: 'post',
    data: data
  })
}

// 获取JS-SDK权限验证配置
export const getWxConfig = (data = {}) => {
  return instance({
    url: '/admin/official/Wechat/getWxConfig',
    method: 'post',
    data: data
  })
}

// 检查视频是否已经上传，并返回id
export const checkVideoHadDecode = (params = {}, options = {}) => {
  return instance({
    method: 'get',
    url: '/creative/ka/VideoDecode/checkVideo',
    params,
    ...options
  })
}

// 添加反馈
export const addFeedback = (data = {}) => {
  return instance({
    url: '/user/user/Feedback/add',
    method: 'post',
    data: data
  })
}

// AI智能生成文本
export const textGenerationDemo = (data = {}) => {
  return instance({
    url: '/creative/api/AiTextApi/get',
    method: 'get',
    params: data
  })
}

// 微信下单
export const wechatCreateOrder = (data = {}) => {
  return instance({
    url: '/user/user/Wechat/createOrder',
    method: 'post',
    data: signParams(data)
  })
}

// 工作区 批量下载-轮询 获取下载链接
export const querySuccessTask = (params = {}, options = {}) => {
  return instance({
    url: '/creative/creative/tasks/querySuccessTask',
    method: 'get',
    params,
    ...options
  })
}

// 素材原料 批量下载-轮询 获取下载链接
export const downloadElement = (data = {}, options = {}) => {
  return instance({
    url: '/creative/creative/UserGroup/downloadElements',
    method: 'post',
    data,
    ...options
  })
}

// 获取子账号
export const queryAdvertiserSubAccountList = (data = {}) => {
  return instance({
    url: '/user/user/SubAccount/queryAdvertiserSubAccountList',
    method: 'post',
    data: data
  })
}
